import styled from '@emotion/styled'
import { AudioOnlyButton } from '@liveHelper/components/shared/styles'
import { CHAT_HEADER_HEIGHT } from '@oneToOne/shared/components/chat/constants'
import type { ChatColorTheme } from '@oneToOne/shared/components/chat/theme/ChatThemeContext'
import { FadeInNoDelayAnimation, FlexCenter } from '@oneToOne/shared/styles'

export const ChatHeaderRingingWrapper = styled.div<{ theme: ChatColorTheme }>`
  ${FlexCenter}
  ${FadeInNoDelayAnimation}
  flex-direction: column;
  flex-grow: 1;
  width: 100%;
  height: ${CHAT_HEADER_HEIGHT.videoContainer}px;
  border-bottom: 1px solid
    ${({ theme }) =>
      theme === 'light' ? 'var(--gray-4)' : 'var(--cool-gray-800)'};
  background: ${({ theme }) =>
    theme === 'light' ? 'var(--white)' : 'var(--cool-gray-900)'};
`

export const VideoContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  background: var(--gray-10);
  min-height: 160px;
`

export const AudioButtonWrapper = styled.div`
  ${FlexCenter}
  flex-grow: 1;
  width: 100%;
  padding: var(--spacing-8) var(--spacing-6);
`

export const ChatRingingButtonRow = styled.div<{ theme: ChatColorTheme }>`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: ${({ theme }) =>
    theme === 'light' ? 'var(--gray-9)' : 'var(--cool-gray-200)'};
  background: ${({ theme }) =>
    theme === 'light' ? '#fff' : 'var(--cool-gray-1000)'};
  height: 52px;
  gap: var(--spacing-8);
  padding: 0 var(--spacing-12);
`

export const RingingButton = styled(AudioOnlyButton)`
  border-radius: var(--spacing-4);
`
